import { User } from "./user";
import { EUserType } from "../enum/e-user-type";
import { Observable } from "rxjs";
import { Package } from "../../packages/models/package";
import { UserApiService } from "../user-api.service";
import { Injector } from "@angular/core";
import { Subscription } from "../../subscription/models/subscription";

export class UserAdmin extends User  {

  discriminator: EUserType = EUserType.Admin;

  constructor(public injector: Injector) {
    super(injector);
  }

  
  public getPackage(): Observable<Package[]> {
    
    return this.injector.get(UserApiService).getPackage(this);

  }

  getSubscriptions(): Observable<Subscription[]> {
    throw new Error("Method not implemented.");
  }

}
